var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c(
              "div",
              { staticClass: "bg-purple bcGrey" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "grey padding10",
                    attrs: { "label-position": "left", "label-width": "auto" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "渠道单号" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: { placeholder: "请输入订单号", type: "text" },
                          on: { blur: _vm.handleBlur },
                          model: {
                            value: _vm.data.channelOrderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "channelOrderNo", $$v)
                            },
                            expression: "data.channelOrderNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "线上店铺" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "260px" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择线上店铺",
                            },
                            model: {
                              value: _vm.data.cshop,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "cshop", $$v)
                              },
                              expression: "data.cshop",
                            },
                          },
                          _vm._l(_vm.shopList, function (item) {
                            return _c("el-option", {
                              key: item.sid,
                              attrs: {
                                label: item.cname,
                                value: item.rplatShop,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "出货门店" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "260px" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择出货门店",
                            },
                            model: {
                              value: _vm.data.rstore,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "rstore", $$v)
                              },
                              expression: "data.rstore",
                            },
                          },
                          _vm._l(_vm.storeList, function (item) {
                            return _c("el-option", {
                              key: item.sid,
                              attrs: { label: item.cname, value: item.sid },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顾客姓名" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请输入顾客姓名",
                            type: "text",
                          },
                          model: {
                            value: _vm.data.customerName,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "customerName", $$v)
                            },
                            expression: "data.customerName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顾客电话" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请输入顾客电话",
                            type: "text",
                          },
                          model: {
                            value: _vm.data.customerPhone,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "customerPhone", $$v)
                            },
                            expression: "data.customerPhone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顾客地址" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请输入顾客地址",
                            type: "textarea",
                          },
                          model: {
                            value: _vm.data.customerAddr,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "customerAddr", $$v)
                            },
                            expression: "data.customerAddr",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顾客详细地址" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请输入顾客详细地址",
                            type: "textarea",
                          },
                          model: {
                            value: _vm.data.customerAddrDetail,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "customerAddrDetail", $$v)
                            },
                            expression: "data.customerAddrDetail",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "期望送达时间" } },
                      [
                        _c("el-time-select", {
                          staticStyle: { width: "260px" },
                          attrs: { placeholder: "选择时间" },
                          model: {
                            value: _vm.data.wishTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wishTime", $$v)
                            },
                            expression: "data.wishTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顾客实付" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请输入顾客实付（单位：元）",
                            type: "text",
                          },
                          model: {
                            value: _vm.data.priceCustomer,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "priceCustomer", $$v)
                            },
                            expression: "data.priceCustomer",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "经度" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请点击地图获取",
                            type: "text",
                          },
                          model: {
                            value: _vm.data.customerLongitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "customerLongitude", $$v)
                            },
                            expression: "data.customerLongitude",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "纬度" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "260px" },
                          attrs: {
                            placeholder: "请点击地图获取",
                            type: "text",
                          },
                          model: {
                            value: _vm.data.customerLatitude,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "customerLatitude", $$v)
                            },
                            expression: "data.customerLatitude",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "配送方式" } },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.data.deliveryType,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deliveryType", $$v)
                              },
                              expression: "data.deliveryType",
                            },
                          },
                          [_vm._v("同城配送")]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "2" },
                            model: {
                              value: _vm.data.deliveryType,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deliveryType", $$v)
                              },
                              expression: "data.deliveryType",
                            },
                          },
                          [_vm._v("顾客自提")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("el-col", { attrs: { span: 8 } }, [
            _c(
              "div",
              { staticClass: "bg-purple-light bcGrey hHP" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form-goods",
                    staticClass: "grey padding10",
                    attrs: { "label-width": "auto" },
                  },
                  [
                    _vm.goodsList.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "bcGrey padding10 marginBottom10 scrollbar",
                            staticStyle: { height: "290px" },
                          },
                          _vm._l(_vm.goodsList, function (goods, index) {
                            return _c(
                              "div",
                              { key: goods.sid, staticClass: "marginBottom10" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "wHP bcWhite flex padding5" },
                                  [
                                    _c("el-image", {
                                      staticClass: "w60 h60 marginRight5",
                                      attrs: {
                                        "preview-src-list": [goods.cmasterUrl],
                                        fit: "fit",
                                        src: goods.cmasterUrl,
                                      },
                                    }),
                                    _c("div", { staticClass: "flex1" }, [
                                      _c("div", { staticClass: "fs20 blue" }, [
                                        _vm._v(_vm._s(goods.cname)),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex marginTopAuto alignItemsCenter",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "35%" } },
                                            [
                                              _vm._v(
                                                "单价: " + _vm._s(goods.nprice)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "flexGrow" },
                                            [
                                              _vm._v(
                                                "数量: " + _vm._s(goods.num)
                                              ),
                                            ]
                                          ),
                                          _c("el-button", {
                                            staticStyle: {
                                              "margin-left": "auto",
                                            },
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemoveGoods(
                                                  index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "wHP block",
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.handleShowChooseGoods },
                      },
                      [_vm._v("+ 添加货品")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticStyle: { height: "800px", width: "400px" } }, [
              _c("div", { staticClass: "hHP wHP", attrs: { id: "container" } }),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.handleClose },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "添加货品",
            visible: _vm.dialogVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("inventOrderGoodsAdd", {
                attrs: { "select-store": { rstore: _vm.data.rstore } },
                on: {
                  handleClose: function ($event) {
                    _vm.dialogVisible = false
                  },
                  handleChoose: _vm.handleChooseGiveGoods,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }